const formatAbandonmentCart = (cart: {
  step?: string | null;
  adviserId?: string;
  kycStatusLabel?: string;
}) => {
  const { step, adviserId, kycStatusLabel } = cart;

  const steps: Record<string, string> = {
    '1': `${adviserId ? 'Application review' : 'Appropriateness'} (1/4)`,
    '2': `${simplifyKycStatusLabel(kycStatusLabel)} (2/4)`,
    '3': 'Bank and tax details (3/4)',
    '4': 'Subscription selection (4/4)',
  };

  return step ? steps[step] ?? '' : adviserId ? 'Invited, no action taken' : '';
};

const simplifyKycStatusLabel = (kycStatusLabel?: string) => {
  if (!kycStatusLabel) return 'KYC';
  return 'KYC start';
};

export default formatAbandonmentCart;
